function copyCommonProperties(fromObject, toObject, ignore = []) {
    let myProps = Object.keys(toObject);
    Object.keys(fromObject).forEach(key => {
        let ignored = ignore && ignore.includes(key);
        if(!ignored && myProps.includes(key)) {
            toObject[key] = fromObject[key];
        }
    });
}

export { copyCommonProperties }


// WEBPACK FOOTER //
// ./src/framework/utils.js